import { Static } from "../interfaces/Static";

export const getDropdownsByID = (
  id: string,
  statics: Static[],
  sorted?: boolean
) => {
  const unsorted = statics?.filter((s) => s?.type === id) || [];

  if (sorted) {
    return unsorted.sort((a, b) => a.description.localeCompare(b.description));
  }
  return unsorted;
};

export const getCodeByDescription = (
  description: string,
  statics: Static[] | undefined
) =>
  statics?.find(
    (s) => s?.description?.toLowerCase() === description?.toLowerCase()
  )?.code || "";

export const getDescriptionByCode = (code: any, statics: Static[]) =>
  statics.filter((s) => s.code === code)[0]?.description || "";

export function isSouthAfricanID(idType: string) {
  return idType === "SOUTH AFRICAN ID NUMBER";
}

export const getDays = () => {
  let days: string[] = [];
  for (let index = 1; index <= 31; index++) {
    if (index < 10) {
      days.push(`0${index}`);
    } else {
      days.push(index.toString());
    }
  }
  return days;
};

export const sortFields = (list: Static[]) => {
  return list.sort((a, b) => a.description.localeCompare(b.description));
};

export const getMonths = () => {
  return [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];
};

export const getYears = (min18Years?: boolean) => {
  let startYear;
  if (min18Years) {
    startYear = new Date().getFullYear() - 18;
  } else {
    startYear = new Date().getFullYear();
  }
  const earliestYear = startYear - 110;

  let years: string[] = [];
  for (let index = startYear; index >= earliestYear; index--) {
    years.push(index.toString());
  }
  return years;
};

export const getMonthNumber = (month: string) => {
  switch (month) {
    case "January":
      return "01";

    case "February":
      return "02";

    case "March":
      return "03";

    case "April":
      return "04";

    case "May":
      return "05";

    case "June":
      return "06";

    case "July":
      return "07";

    case "August":
      return "08";

    case "September":
      return "09";

    case "October":
      return "10";

    case "November":
      return "11";

    case "December":
      return "12";

    default:
      return "Wrong Month";
  }
};

export const getMonthString = (month: string) => {
  switch (month) {
    case "01":
      return "January";

    case "02":
      return "February";

    case "03":
      return "March";

    case "04":
      return "April";

    case "05":
      return "May";

    case "06":
      return "June";

    case "07":
      return "July";

    case "08":
      return "August";

    case "09":
      return "September";

    case "10":
      return "October";

    case "11":
      return "November";

    case "12":
      return "December";

    default:
      return "Wrong Month";
  }
};

export const getVehicleYears = () => {
  const startYear = new Date().getFullYear();
  const earliestYear = 1980;

  let years: string[] = [];
  for (let index = startYear; index >= earliestYear; index--) {
    years.push(index.toString());
  }
  return years;
};
